import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import ShieldcheckIcon from 'icons/Shieldcheck.icon';
import useMatchMedia from 'hooks/useMatchMedia';

import './BossModeBanner.styles.scss';

type BossModeBannerProps = {
  className?: string;
  description?: string;
};

const BossModeBanner: React.FC<BossModeBannerProps> = (props) => {
  const { className, description } = props;

  const { t } = useTranslation();

  const classes = classNames('boss-mode-banner', className);

  const isPhablet = useMatchMedia('isPhablet');

  if (isPhablet) return null;

  return (
    <div className={classes}>
      <ShieldcheckIcon />

      <div>
        <span>{t('warningBossMode')}</span>
        <span>{description || t('warningEditingCustomerListings')}</span>
      </div>
    </div>
  );
};

export default BossModeBanner;
